import { Component, Input, OnInit } from '@angular/core';
import { RibbonTileSection } from 'src/app/model/section/ribbon-tile-section';

@Component({
  selector: 'app-functional-capabilities-disruption-handling-start-ribbon-tile-section',
  templateUrl: './functional-capabilities-disruption-handling-start-ribbon-tile-section.component.html',
  styleUrls: ['./functional-capabilities-disruption-handling-start-ribbon-tile-section.component.scss']
})
export class FunctionalCapabilitiesDisruptionHandlingStartRibbonTileSectionComponent implements OnInit {
  @Input() ribbonTileSections: RibbonTileSection[] = [];
  @Input() isDisruptionHandlingStartPage: boolean = false;
  @Input() isAPIFlow: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
